import { CommonActions } from '@react-navigation/native';
import { isTokenError } from 'Utils/mCoreUtils';
import { logEvent } from 'AppManager';
import NavigationService from 'NavigationService';
import { SystemInfoHelper } from '../../../AppManager/helpers/SystemInfoHelper';

const resetAction = CommonActions.reset({
    index: 1,
    actions: [CommonActions.navigate({ name: 'Main' }), CommonActions.navigate({ name: 'Login' })]
});

export const onError = (props) => async (errorResponse) => {
    const { appManager, navigation, setUserData, setPlayerData } = props;
    if (isTokenError(errorResponse)) {
        await appManager.clearLoginData();
        await appManager.initialize();
        setUserData(null);
        setPlayerData(null);
        navigation.dispatch(resetAction);
    }
    const currentRoute = NavigationService.getCurrentRoute();
    const systemInfo = new SystemInfoHelper();
    await systemInfo.load();
    if (errorResponse.errorCode === 'NO_LOGGED') {
        logEvent({
            type: 'error',
            subtype: 'navigation',
            error: 'notLoggedIn',
            context: currentRoute,
            ...systemInfo.get()
        });
    } else {
        logEvent({
            type: 'error',
            subtype: currentRoute,
            error: errorResponse.errorCode,
            ...systemInfo.get()
        });
    }
};
